const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

// Fetch all articles
export const fetchArticles = async () => {
  try {
    console.log('Fetching articles from API:', `${API_URL}/articles`);
    const response = await fetch(`${API_URL}/articles`);
    console.log('Fetch articles response:', response);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    console.log('Fetched articles data:', data);

    return data.data || []; // Return the articles array
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

// Fetch single article by ID
export const fetchArticleById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/articles/${id}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
};

// Create new article
export const createArticle = async (articleData) => {
  try {
    console.log('Creating article:', articleData);
    const response = await fetch(`${API_URL}/articles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(articleData),
    });
    console.log('Create article response:', response);
    console.log('Create article response status:', response.status);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create article');
    }
    
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error creating article:', error);
    throw error;
  }
};

// Update article
export const updateArticle = async (id, articleData) => {
  try {
    const response = await fetch(`${API_URL}/articles/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(articleData),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update article');
    }
    
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error updating article:', error);
    throw error;
  }
};

// Delete article
export const deleteArticle = async (id) => {
  try {
    const response = await fetch(`${API_URL}/articles/${id}`, {
      method: 'DELETE',
    });

    console.log('Delete article response:', response);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to delete article');
    }
    
    return true;
  } catch (error) {
    console.error('Error deleting article:', error);
    throw error;
  }
};
